import { createContext } from "react";

const TwiterIdsProvider = createContext({
  pages_ids: [],
  setPagesIds: () => {},
});

export default TwiterIdsProvider;
